import { Theme } from "@mui/material";

// Section card skin shared across record-view modals and config cards
export const sectionCardSx = (theme: Theme) => ({
  background: theme.palette.surface.cardGradient,
  border: `1px solid ${theme.palette.surface.border}`,
  borderRadius: "20px",
  boxShadow: "none",
});

export default sectionCardSx;
